<template>
  <div class="lottodashboard">
    <div class="mt-2" id="highlight">
      <b-container>
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mb-2 pr-sm-1 p-0">
            <div class="dashboard-panel dashboard-panel--highlighted shadow-sm rounded p-2 h-100">
              <h6 class="text-gold">
                <i class="far fa-gem"></i> จับยี่กี VIP - รอบที่ {{ results.lastestPingpong ? results.lastestPingpong.roundNumber : '' }}
                <span
                  class="badge badge-warning text-white"
                >
                  {{ results.lastestPingpong ? formatDate(results.lastestPingpong.lottoDate, "DD MMMM YYYY") : '' }}
                </span>
              </h6>
              <b-container class="pt-3 px-3 pb-0">
                <b-row>
                  <b-col class="px-1">
                    <div class="card text-center">
                      <div class="card-header text-gold p-1 m-0">
                        3 ตัวบน
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.lastestPingpong ? results.lastestPingpong.topThree : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card text-center">
                      <div class="card-header text-gold p-1 m-0">
                        2 ตัวล่าง
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.lastestPingpong ? results.lastestPingpong.twoDown : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mb-2 p-0">
            <div class="dashboard-panel shadow-sm rounded p-2 h-100 xtarget" id="government">
              <h6>
                <span class="flag-icon flag-icon-th"></span>
                หวยรัฐบาล
                <span class="badge badge-dark">{{ results.thaiLotto ? formatDate(results.thaiLotto.lottoDate, "DD MMMM YYYY") : '' }}</span>
              </h6>
              <b-container>
                <b-row>
                  <b-col cols="12" class="px-1">
                    <div class="card border-dark text-center mb-2">
                      <div class="card-header text-gold p-1 m-0"></div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.thaiLotto ? results.thaiLotto.longResult : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0">
                        3 ตัวหน้า
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.thaiLotto ? results.thaiLotto.threeFront : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0">
                        3 ตัวท้าย
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.thaiLotto ? results.thaiLotto.downThree : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0">
                        2 ตัวล่าง
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.thaiLotto ? results.thaiLotto.twoDown : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mb-2 pr-sm-1 p-0">
            <div class="dashboard-panel shadow-sm rounded p-2 h-100 xtarget" id="government">
              <h6>
                <span class="flag-icon flag-icon-gsb"></span>
                หวย ออมสิน
                <span class="badge badge-dark">{{ results.aomsinLotto ? formatDate(results.aomsinLotto.lottoDate, "DD MMMM YYYY") : '' }}</span>
              </h6>
              <b-container>
                <b-row>
                  <b-col class="px-1" cols="12">
                    <div class="card border-dark text-center mb-2">
                      <div class="card-header text-gold p-1 m-0">รางวัลเลขท้าย 6 ตัว</div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.aomsinLotto ? results.aomsinLotto.longResult : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0" style="line-height:1.2">
                        <small>3 ตัวบน</small>
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.aomsinLotto ? results.aomsinLotto.topThree : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0" style="line-height:1.2">
                        <small>2 ตัวล่าง</small>
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.aomsinLotto ? results.aomsinLotto.twoDown : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="mb-2 p-0">
            <div class="dashboard-panel shadow-sm rounded p-2 h-100 xtarget" id="government">
              <h6>
                <span class="flag-icon flag-icon-baac"></span>
                หวย ธกส.
                <span class="badge badge-dark">{{ results.bAACLotto ? formatDate(results.bAACLotto.lottoDate, "DD MMMM YYYY") : '' }}</span>
              </h6>
              <b-container>
                <b-row>
                  <b-col class="px-1" cols="12">
                    <div class="card border-dark text-center mb-2">
                      <div class="card-header text-gold p-1 m-0">เลขที่ออก</div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.bAACLotto ? results.bAACLotto.longResult : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0" style="line-height:1.2">
                        <small>3 ตัวบน</small>
                        <br />
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.bAACLotto ? results.bAACLotto.topThree : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="px-1">
                    <div class="card border-dark text-center">
                      <div class="card-header text-gold p-1 m-0" style="line-height:1.2">
                        <small>2 ตัวล่าง</small>
                      </div>
                      <div class="card-body p-1">
                        <p class="card-text">{{ results.bAACLotto ? results.bAACLotto.twoDown : ''}}</p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="dashboard-panel shadow-sm rounded p-2 xtarget" id="thaiStock">
      <h6>
        <i class="fas fa-star"></i> หวยหุ้นไทย
        <span class="badge badge-dark">{{ results.thaiStockLotto ? formatDate(results.thaiStockLotto.lottoDate, "DD MMMM YYYY") : '' }}</span>
      </h6>
      <b-container>
        <b-row>
          <b-col cols="12" class="px-2">
            <div class="card-group">
              <div class="card border-dark text-center mb-8">
                <div class="card-header text-gold p-1 m-0">หุ้นไทยเย็น</div>
                <div class="card-body p-0">
                  <div class="d-flex flex-row">
                    <div class="card text-center w-50 border-card-right">
                      <div class="card-header sub-card-header bg-transparent p-0">
                        3 ตัวบน
                        <br />
                      </div>
                      <div class="card-body p-0">
                        <p class="card-text">{{ results.thaiStockLotto ? results.thaiStockLotto.topThree : ''}}</p>
                      </div>
                    </div>
                    <div class="card text-center w-50 border-card-right">
                      <div class="card-header sub-card-header bg-transparent p-0 m-0">
                        2 ตัวล่าง
                        <br />
                      </div>
                      <div class="card-body p-0">
                        <p class="card-text">{{ results.thaiStockLotto ? results.thaiStockLotto.twoDown : ''}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="dashboard-panel shadow-sm rounded p-2 xtarget" id="foreignStock">
      <h6>
        <i class="far fa-star"></i> หวยหุ้นต่างประเทศ
        <span class="badge badge-dark">{{ foreignSTK ? formatDate(results[foreignSTK[0].name].lottoDate, "DD MMMM YYYY") : '' }}</span>
      </h6>
      <b-container class="d-none d-sm-block px-0">
        <b-row class="px-0 m-0">
          <b-col
            xs="12"
            sm="12"
            md="6"
            lg="4"
            xl="4"
            class="px-2"
            v-for="(item,index) in foreignSTK"
            v-bind:key="index"
          >
            <div class="card border-dark text-center mb-2">
              <div class="card-header text-gold p-1 m-0">
                <span :class="['flag-icon','flag-icon-small',item.flag]"></span>
                {{item.title}}
              </div>
              <div class="card-body p-0">
                <div class="d-flex flex-row">
                  <div class="card text-center w-50 border-card-right m-0">
                    <div class="card-header sub-card-header bg-transparent p-0 font-weight-bold">
                      3 ตัวบน
                      <br />
                    </div>
                    <div class="card-body p-0 font-weight-bold">
                      <p class="card-text">
                        {{results[item.name].topThree}}
                      </p>
                    </div>
                  </div>
                  <div class="card text-center w-50 border-card-right m-0">
                    <div class="card-header sub-card-header bg-transparent p-0 font-weight-bold">
                      2 ตัวล่าง
                      <br />
                    </div>
                    <div class="card-body p-0 font-weight-bold">
                      <p class="card-text">
                        {{results[item.name].twoDown}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <b-container class="d-block d-sm-none px-0">
        <ul class="fs-indicator d-flex flex-wrap">
          <li
            v-for="(item,index) in foreignSTK"
            v-bind:key="index"
            :class="foreignSTKSelected == index ? 'active indicator-flex' : 'indicator-flex'"
            @click="foreignSTKSelected = index"
            data-target="#carouselExampleSlidesOnly"
            :data-slide-to="index"
          >
            <span :class="['flag-icon','flag-icon-indicator',item.flag]"></span>
            {{item.title}}
          </li>
        </ul>
        <b-row class="mb-2">
          <b-col>
            <b-btn
              variant="dark"
              size="sm"
              :disabled="foreignSTKSelected == 0 ? true : false"
              @click="foreignSTKSelected > 0 ? foreignSTKSelected-- : false"
            >
              <i class="fas fa-chevron-left"></i> Previous
            </b-btn>
          </b-col>
          <b-col class="text-right">
            <b-btn
              variant="dark"
              size="sm"
              :disabled="foreignSTKSelected == foreignSTK.length-1 ? true : false"
              @click="foreignSTKSelected < foreignSTK.length-1 ? foreignSTKSelected++ : false"
            >
              Next
              <i class="fas fa-chevron-right"></i>
            </b-btn>
          </b-col>
        </b-row>
      </b-container>

      <b-container class="d-block d-sm-none px-0">
        <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div
              :class="index == foreignSTKSelected ? 'active carousel-item' : 'carousel-item'"
              v-for="(item,index) in foreignSTK"
              v-bind:key="index"
            >
              <b-card border-variant="secondary" header-class="p-0 text-center" body-class="p-0">
                <template #header>
                  <div class="text-gold p-1 mb-1">
                    <span :class="['flag-icon','flag-icon-small',item.flag]"></span>
                    {{item.title}}
                  </div>
                </template>
                <div class="d-flex flex-row">
                  <b-card
                    class="w-50"
                    header="3&nbsp;ตัวบน"
                    header-bg-variant="white"
                    header-class="p-0 text-center font-weight-bold m-0"
                    body-class="p-0 text-center font-weight-bold"
                  >
                    <template #header>3&nbsp;ตัวบน</template>
                    {{results[item.name].topThree}}
                  </b-card>
                  <b-card
                    class="w-50"
                    header-bg-variant="white"
                    header-class="p-0 text-center font-weight-bold"
                    body-class="p-0 text-center font-weight-bold"
                  >
                    <template #header>2&nbsp;ตัวล่าง</template>
                    {{results[item.name].twoDown}}
                  </b-card>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </b-container>
    </div>
    <div class="dashboard-panel shadow-sm rounded p-2 xtarget" id="yeekee">
      <h6>
        <i class="fas fa-trophy"></i> จับยี่กี VIP
        <span class="badge badge-dark">{{ lottoDate ? formatDate(lottoDate, "DD MMMM YYYY") : formatDate(null, "DD MMMM YYYY") }}</span>
      </h6>
      <b-container class="mb-2 px-2 d-block d-sm-none">
        <b-row>
          <b-col cols="6" class="px-2">
            <b-btn
              :variant="yeekeeView == 'short' ? 'dark' : 'outline-dark'"
              @click="yeekeeView = 'short'"
              class="font-weight-bold"
              block
            >มุมมองสั้น</b-btn>
          </b-col>
          <b-col cols="6" class="px-2">
            <b-btn
              :variant="yeekeeView == 'long' ? 'dark' : 'outline-dark'"
              @click="yeekeeView = 'long'"
              class="font-weight-bold"
              block
            >มุมมองยาว</b-btn>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="px-0" v-if="yeekeeView == 'short'">
        <ul class="yk-indicator mt-2">
          <li
            v-for="(item,index) in results.pingpongList"
            v-bind:key="index"
            :class="yeekeeSelected == index ? 'active' : ''"
            @click="yeekeeSelected = index"
            data-target="#carouselExampleSlidesYK"
            :data-slide-to="index"
          >{{item.roundNumber}}</li>
        </ul>
        <b-row class="mb-2">
          <b-col>
            <b-btn
              variant="dark"
              size="sm"
              :disabled="yeekeeSelected == 0 ? true : false"
              @click="yeekeeSelected > 0 ? yeekeeSelected-- : false"
            >
              <i class="fas fa-chevron-left"></i> Previous
            </b-btn>
          </b-col>
          <b-col class="text-right">
            <b-btn
              variant="dark"
              size="sm"
              :disabled="yeekeeSelected == results.pingpongList.length-1 ? true : false"
              @click="yeekeeSelected < results.pingpongList.length-1 ? yeekeeSelected++ : false"
            >
              Next
              <i class="fas fa-chevron-right"></i>
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="px-0" v-if="yeekeeView == 'short'">
        <div id="carouselExampleSlidesYK" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div
              :class="index == yeekeeSelected ? 'active carousel-item' : 'carousel-item'"
              v-for="(item,index) in results.pingpongList"
              v-bind:key="index"
            >
              <b-card
                border-variant="secondary"
                header-class="p-0 text-center m-0"
                body-class="p-0"
              >
                <template #header>
                  <div class="text-gold p-1 mb-1">จับยี่กี VIP - รอบที่ {{item.roundNumber}}</div>
                </template>
                <div class="d-flex flex-row">
                  <b-card
                    class="w-50"
                    header="3&nbsp;ตัวบน"
                    header-bg-variant="white"
                    header-class="p-0 text-center font-weight-bold"
                    body-class="p-0 text-center font-weight-bold"
                  >
                    <template #header>3&nbsp;ตัวบน</template>
                    {{item.topThree}}
                  </b-card>
                  <b-card
                    class="w-50"
                    header-bg-variant="white"
                    header-class="p-0 text-center font-weight-bold"
                    body-class="p-0 text-center font-weight-bold"
                  >
                    <template #header>2&nbsp;ตัวล่าง</template>
                    {{item.twoDown}}
                  </b-card>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </b-container>
      <b-container class="px-2" v-if="yeekeeView == 'long'">
        <b-row>
          <b-col
            v-for="yeekee in results.pingpongList"
            xs="12"
            sm="12"
            md="6"
            lg="3"
            xl="3"
            class="px-2"
            v-bind:key="yeekee.roundNumber"
          >
            <div class="card border-secondary text-center mb-2">
              <div class="card-header text-gold p-1 m-0">จับยี่กี VIP - รอบที่ {{yeekee.roundNumber}}</div>
              <div class="card-body p-0">
                <div class="d-flex flex-row">
                  <div class="card text-center w-50 border-card-right m-0 font-weight-bold">
                    <div class="card-header sub-card-header bg-transparent p-0">
                      3ตัวบน
                      <br />
                    </div>
                    <div class="card-body p-0">
                      <p class="card-text">{{ yeekee.topThree }}</p>
                    </div>
                  </div>
                  <div class="card text-center w-50 border-card-right m-0 font-weight-bold">
                    <div class="card-header sub-card-header bg-transparent p-0">
                      2ตัวล่าง
                      <br />
                    </div>
                    <div class="card-body p-0">
                      <p class="card-text">{{ yeekee.twoDown }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>

    </div>
    <div class="dashboard-panel shadow-sm rounded p-2 xtarget" id="foreignStock">
      <h6>
        <h4 class="elementor-heading-title elementor-size-large">หวยออนไลน์ jayjinglotto.com แทงหวยออนไลน์ เว็บแทงหวยอันดับ 1 ลาว ฮานอย ยี่กี หุ้น</h4>
      </h6>
      <b-container class="d-none d-sm-block px-0">
        <b-row class="px-0 m-0">
          <p style="text-align: left;"><a title="หวยออนไลน์" href="https://jayjinglotto.com/"><span style="color: #ffcc00;"><strong>หวยออนไลน์ </strong></span></a> เว็บแทงหวยออนไลน์ 24 ชั่วโมง อันดับ 1 ที่ได้รับความไว้วางใจจากผู้ใช้มากกว่า 3 แสนราย เป็นเว็บไซต์ที่มีการเติบโตเป็นอับดับต้นๆ ของเมืองไทย เราอยากให้คุณมาเป็นครอบครัวthe1ด้วยกัน <span style="font-family: var( --e-global-typography-text-font-family ), Kanit; font-weight: var( --e-global-typography-text-font-weight ); background-color: transparent;">ให้บริการ <span style="color: #ffcc00;"><a style="color: #ffcc00;" title="แทงหวยออนไลน์" href="https://jayjinglotto.com/"><strong>แทงหวยออนไลน์</strong></a> ทุกชนิด</span> <span style="color: #ffcc00;">หวยรัฐบาล, หวยยี่กี, หวยลาว, หวยฮานอย, หวยมาเลย์, สลากออมสิน และ หวยหุ้น downjone และไม่เหมือนใคร หวย BITCOIN ETH APPLE หวย TESLA </span> แทงหวยออนไลน์ ครบวงจรมากที่สุด มี Lottery online ทุกประเภท เปิดตลอด 24 ชั่วโมง จะเล่นกับคอม หรือ <span style="color: #ffcc00;"><strong>แทงหวยออนไลน์ผ่านมือถือ</strong></span> สมัครฟรีไม่มีค่าใช้จ่าย ปลอดภัย ฝาก-ถอนด้วยระบบอัตโนมัติที่ทันสมัยที่สุด ทั้งยังมีเลขเด็ด, ผลหวย, ตรวจหวย, ตรวจสลากกินแบ่งรัฐบาล, สถิติหวย, หวยออมสิน, โปรแกรมหวย, เจาะเลขเด็ด และอื่นๆ ให้อ่านอีกมากมาย เข้าไปดูเลย</span></p>
        </b-row>
      </b-container>

    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "LottoDashboard",
  props: ['lottoDate'],
  data() {
    return {
      results: [],
      yeekeeSelected: 0,
      foreignSTKSelected: 0,
      foreignSTK: [
        {
          flag: "flag-icon-kr",
          code: "KR",
          title: "หุ้นเกาหลี",
          threeTop: 988,
          twoBottom: 72,
          name: 'koreaLotto'
        },
        {
          flag: "flag-icon-jp",
          code: "JP-M",
          title: "นิเคอิรอบเช้า",
          threeTop: 905,
          twoBottom: 21,
          name: 'nikeiMorningLotto'
        },
        {
          flag: "flag-icon-jp",
          code: "JP-A",
          title: "นิเคอิรอบบ่าย",
          threeTop: 918,
          twoBottom: "08",
          name: 'nikeiAfternoonLotto'
        },
        {
          flag: "flag-icon-hk",
          code: "HK-M",
          title: "ฮั่งเส็งรอบเช้า",
          threeTop: 698,
          twoBottom: 12,
          name: 'hangSengMorningLotto'
        },
        {
          flag: "flag-icon-hk",
          code: "HK-A",
          title: "ฮั่งเส็งรอบบ่าย",
          threeTop: 386,
          twoBottom: "00",
          name: 'hangSengAfternoonLotto'
        },
        {
          flag: "flag-icon-cn",
          code: "CN-M",
          title: "จีนรอบเช้า",
          threeTop: 794,
          twoBottom: 19,
          name: 'chinaMorningLotto'
        },
        {
          flag: "flag-icon-cn",
          code: "CN-A",
          title: "จีนรอบบ่าย",
          threeTop: 170,
          twoBottom: 43,
          name: 'chinaAfternoonLotto'
        },
        {
          flag: "flag-icon-tw",
          code: "TW",
          title: "หุ้นไต้หวัน",
          threeTop: 639,
          twoBottom: 80,
          name: 'taiwanLotto'
        },
        {
          flag: "flag-icon-sg",
          code: "SG",
          title: "หุ้นสิงคโปร์",
          threeTop: 487,
          twoBottom: 87,
          name: 'singaporeLotto'
        },
        {
          flag: "flag-icon-eg",
          code: "EG",
          title: "หุ้นอียิปต์",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'egyptLotto'
        },
        {
          flag: "flag-icon-de",
          code: "DE",
          title: "หุ้นเยอรมัน",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'germanLotto'
        },
        {
          flag: "flag-icon-gb",
          code: "GB",
          title: "หุ้นอังกฤษ",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'englandLotto'
        },
        {
          flag: "flag-icon-ru",
          code: "RU",
          title: "หุ้นรัสเซีย",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'russiaLotto'
        },
        {
          flag: "flag-icon-in",
          code: "IN",
          title: "หุ้นอินเดีย",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'indiaLotto'
        },
        {
          flag: "flag-icon-us",
          code: "US",
          title: "หุ้นดาวโจนส์",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'malaysiaLotto'
        },
        {
          flag: "flag-icon-my",
          code: "MY",
          title: "หวยมาเลย์",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'malaysiaLotto'
        },
        {
          flag: "flag-icon-la",
          code: "LA",
          title: "หวยลาว",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'laosLotto'
        },
        {
          flag: "flag-icon-vn",
          code: "VN",
          title: "หวยเวียดนาม",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'hanoiLotto'
        },
        {
          flag: "flag-icon-vn",
          code: "VN-S",
          title: "หวยเวียดนาม/ฮานอยพิเศษ",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'hanoiExtraLotto'
        },
        {
          flag: "flag-icon-eth",
          code: "ETH",
          title: "เหรียญ ETH",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'ETH'
        },
        {
          flag: "flag-icon-bitcoin",
          code: "BITCOIN",
          title: "เหรียญ BITCOIN",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'BITCOIN'
        },
        {
          flag: "flag-icon-apple",
          code: "Apple",
          title: "หุ้น Apple",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'Apple'
        },
        {
          flag: "flag-icon-tesla",
          code: "Tesla",
          title: "หุ้น Tesla",
          threeTop: "xx",
          twoBottom: "xx",
          name: 'Tesla'
        }
      ],
      yeekeeView: "long"
    };
  },
  mounted() {
    this.getResult();
  },
  methods: {
    formatDate(dt,format) {
      if(dt === null) {
        return moment().format(format);
      }
      else {
        return moment(String(dt)).format(format);
      }
    },
    getResult() {
      axios.post(this.getApiUrl + "/pingpong/GetLottoResultTable",
        {
          lottoDate: this.lottoDate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.results = response.data.data;
          console.log('results', this.results);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  },
  watch: {
    lottoDate() {
      this.getResult();
    }
  }
}
</script>

<style lang="scss" scoped>
.lottodashboard {
  .text-gold {
    color: #976f02 !important;
    margin: 5px;
    margin-bottom: 10px;
    text-shadow: 1px 1px 0px rgb(255 255 255 / 30%);
    font-size: 110%;
    font-weight: bold;
  }

  .fs-indicator {
    list-style-type: none;
    // border: 1px solid red;
    padding-inline-start: 0;

    li {
      position: relative;
      -ms-flex: 0 1 auto;
      flex: 0 1 auto;
      display: inline-block;
      /* width: 24% !important; */
      width: 32.1% !important;
      height: auto !important;
      padding: 3px 0;
      text-align: center;
      vertical-align: top;
      margin-right: 1.5px;
      margin-left: 1.5px;
      margin-bottom: 3px;
      text-indent: 0px !important;
      cursor: pointer;
      background-color: rgba(108, 117, 125, 0.2);
      border: 1px solid rgba(108, 117, 125, 0.2);
      font-size: 14px;
      font-weight: 400;
      text-shadow: none;
      border-radius: 2px;

      &.active {
        border: 1px solid #555;
        background-color: rgba(255, 255, 255, 1);
      }

      .flag-icon {
        box-shadow: 0 0 1px rgb(0 0 0 / 30%);
        vertical-align: middle;
        float: left;
        margin-left: 5px !important;
        margin-top: 3px !important;
        border-radius: 0;
        border: 0;
        height: 14px;
        width: 18.66px !important;
      }
    }

    .indicator-flex {
      position: relative;
      -ms-flex: 0 1 auto;
      flex: 0 1 auto;
      display: inline-block;
      /* width: 24% !important; */
      width: 32.1% !important;
      height: auto !important;
      padding: 3px 0;
      text-align: center;
      vertical-align: top;
      margin-right: 1.5px;
      margin-left: 1.5px;
      margin-bottom: 3px;
      text-indent: 0px !important;
      cursor: pointer;
      background-color: rgba(108, 117, 125, 0.2);
      border: 1px solid rgba(108, 117, 125, 0.2);
      font-size: 14px;
      font-weight: 400;
      text-shadow: none;
      border-radius: 2px;

      &.active {
        border: 1px solid #555;
        background-color: rgba(255, 255, 255, 1);
      }

      .flag-icon {
        box-shadow: 0 0 1px rgb(0 0 0 / 30%);
        vertical-align: middle;
        float: left;
        margin-left: 5px !important;
        margin-top: 3px !important;
        border-radius: 0;
        border: 0;
        height: 14px;
        width: 18.66px !important;
      }
    }
  }

  .yk-indicator {
    list-style-type: none;
    // border: 1px solid red;
    padding-inline-start: 0;

    li {
      position: relative;
      -ms-flex: 0 1 auto;
      flex: 0 1 auto;
      display: inline-block;
      /* width: 24% !important; */
      width: 11.25% !important;
      height: auto !important;
      padding: 3px 0;
      text-align: center;
      vertical-align: top;
      margin-right: 1.5px;
      margin-left: 1.5px;
      margin-bottom: 3px;
      text-indent: 0px !important;
      cursor: pointer;
      background-color: rgba(108, 117, 125, 0.2);
      border: 1px solid rgba(108, 117, 125, 0.2);
      font-size: 14px;
      font-weight: 400;
      text-shadow: none;
      border-radius: 2px;

      &.active {
        border: 1px solid #555;
        background-color: rgba(255, 255, 255, 1);
      }
    }
  }
  .dashboard-panel {
    background: rgba(255, 255, 255, 0.9);
    margin-bottom: 10px;
    border: rgba(255, 255, 255, 1) 2px solid;

    &--highlighted {
      border: 2px #f5bd70 solid;

      .card {
        border: 1px #f5bd70 solid;
      }
    }

    .flag-icon {
      font-size: 40px;
      margin-top: -5px;
      margin-left: -5px;
      border-top-left-radius: 4px;
      border-bottom-right-radius: 8px;
      max-width: 50px;
      background-size: cover;
      border: #555 1px solid;
      border-top-color: #ccc;
      border-left-color: #ccc;
      background-position: 50%;
      background-repeat: no-repeat;
      position: relative;
      display: inline-block;
      width: 1.33333333em;
      line-height: 1em;

      &.flag-icon-indicator {
        background-size: contain;
        background-position: 50%;
        background-repeat: no-repeat;
        position: relative;
        display: inline-block;
        width: 1.33333333em;
        line-height: 1em;
      }

      &.flag-icon:before {
        content: "\00a0";
      }

      &.flag-icon-small {
        font-size: 30px;
        // top: 5px;
        // left: 5px;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 8px;
        max-width: 50px;
        background-size: cover;
        display: inline-block;
        float: left;
        border: #555 1px solid;
        border-top-color: #333;
        border-left-color: #333;
        position: relative;
      }

      &.flag-icon-th {
        background-image: url(../assets/flags/4x3/th.svg);
      }

      &.flag-icon-gsb {
        background-color: #f90a86;
      }

      &.flag-icon-baac {
        background-color: #13007d;
      }

      &.flag-icon-jp {
        background-image: url(../assets/flags/4x3/jp.svg);
      }

      &.flag-icon-kr {
        background-image: url(../assets/flags/4x3/kr.svg);
      }

      &.flag-icon-hk {
        background-image: url(../assets/flags/4x3/hk.svg);
      }

      &.flag-icon-cn {
        background-image: url(../assets/flags/4x3/cn.svg);
      }

      &.flag-icon-tw {
        background-image: url(../assets/flags/4x3/tw.svg);
      }

      &.flag-icon-sg {
        background-image: url(../assets/flags/4x3/sg.svg);
      }

      &.flag-icon-eg {
        background-image: url(../assets/flags/4x3/eg.svg);
      }

      &.flag-icon-de {
        background-image: url(../assets/flags/4x3/de.svg);
      }

      &.flag-icon-gb {
        background-image: url(../assets/flags/4x3/gb.svg);
      }

      &.flag-icon-ru {
        background-image: url(../assets/flags/4x3/ru.svg);
      }

      &.flag-icon-in {
        background-image: url(../assets/flags/4x3/in.svg);
      }

      &.flag-icon-us {
        background-image: url(../assets/flags/4x3/us.svg);
      }

      &.flag-icon-my {
        background-image: url(../assets/flags/4x3/my.svg);
      }

      &.flag-icon-la {
        background-image: url(../assets/flags/4x3/la.svg);
      }

      &.flag-icon-vn {
        background-image: url(../assets/flags/4x3/vn.svg);
      }

      &.flag-icon-eth {
        background-image: url(../assets/flags/4x3/eth.svg);
        background-size: contain;
      }
      &.flag-icon-bitcoin {
        background-image: url(../assets/flags/4x3/bitcoin.svg);
        background-size: contain;
      }
      &.flag-icon-apple {
        background-image: url(../assets/flags/4x3/apple.svg);
        background-size: calc(100% - 20px);

        @media screen and (max-width: 575px) {
          background-size: contain;
        }
      }
      &.flag-icon-tesla {
        background-image: url(../assets/flags/4x3/tesla.svg);
        background-size: contain;
      }
    }
  }
}
</style>
